import { drawAvwapAlarm } from './drawAvwapAlarm.js'

// Selection and armed-alert adornments only; never adds timeline data.
export class AnchoredVwapSelectionPrimitive {
  constructor() {
    this.point = null
    this.alert = null
    const renderer = { draw: target => this.draw(target) }
    this.views = [{ zOrder: () => 'top', renderer: () => renderer }]
  }
  attached({ chart, series, requestUpdate }) { this.chart = chart; this.series = series; this.requestUpdate = requestUpdate }
  detached() { this.chart = null; this.series = null; this.requestUpdate = null; this.point = null; this.alert = null }
  setPoint(point) { this.point = point; this.requestUpdate?.() }
  setAlert(alert) { this.alert = alert; this.requestUpdate?.() }
  paneViews() { return this.views }
  updateAllViews() {}
  draw(target) {
    this.drawAlert(target)
    if (!this.point || !this.chart || !this.series) return
    const x = this.chart.timeScale().timeToCoordinate(this.point.time)
    const y = this.series.priceToCoordinate(this.point.value)
    if (![x, y].every(Number.isFinite)) return
    target.useMediaCoordinateSpace(({ context: ctx, mediaSize }) => {
      if (x < 0 || x > mediaSize.width || y < 0 || y > mediaSize.height) return
      ctx.save(); ctx.beginPath(); ctx.arc(x, y, 5, 0, Math.PI * 2)
      ctx.fillStyle = typeof document !== 'undefined' && document.documentElement.classList.contains('dark') ? '#262626' : '#ffffff'
      ctx.fill(); ctx.lineWidth = 1.5; ctx.strokeStyle = '#2962ff'; ctx.stroke(); ctx.restore()
    })
  }
  drawAlert(target) {
    if (!this.alert?.point || !this.series) return
    const y = this.series.priceToCoordinate(this.alert.point.value)
    if (!Number.isFinite(y)) return
    target.useMediaCoordinateSpace(({ context: ctx, mediaSize }) => {
      if (y < 10 || y > mediaSize.height - 10) return
      const endX = this.chart?.timeScale().timeToCoordinate(this.alert.point.time)
      if (!Number.isFinite(endX) || endX < 0) return
      const x = Math.min(endX + 14, mediaSize.width - 12)
      drawAvwapAlarm(ctx, x, y, this.alert.color)
    })
  }

}
